// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"d8b328da","453":"68693753","624":"1287eec7","975":"7ede6312"}[chunkId] + ".chunk.js";
};